var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1083 -111)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.413,9.471,20.529,5.587A2,2,0,0,0,19.113,5H7A2,2,0,0,0,5,7V23a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V10.887a2,2,0,0,0-.587-1.416ZM16.556,6.333v3.778a.222.222,0,0,1-.222.222H9.667a.222.222,0,0,1-.222-.222V6.333ZM9.444,23.667V17.444a.222.222,0,0,1,.222-.222H20.333a.222.222,0,0,1,.222.222v6.222ZM23.667,23a.667.667,0,0,1-.667.667H21.889V17.444a1.556,1.556,0,0,0-1.556-1.556H9.667a1.556,1.556,0,0,0-1.556,1.556v6.222H7A.667.667,0,0,1,6.333,23V7A.667.667,0,0,1,7,6.333H8.111v3.778a1.556,1.556,0,0,0,1.556,1.556h6.667a1.556,1.556,0,0,0,1.556-1.556V6.333h1.224a.667.667,0,0,1,.473.2l3.884,3.884a.667.667,0,0,1,.2.473Z",
    transform: "translate(1078 106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.441,67.553h6.622a.441.441,0,0,0,0-.883H33.441a.441.441,0,1,0,0,.883Z",
    transform: "translate(1056.247 58.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.441,79.213h6.622a.441.441,0,1,0,0-.883H33.441a.441.441,0,1,0,0,.883Z",
    transform: "translate(1056.247 48.99)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.40519a6df12f162d42ed04f3a1993ceb.svg";
export { ForwardRef as ReactComponent };